import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

export class CompletedMatches extends APIBaseFunctions {
  static CompletedMatchScoreDataService = class {
    private static completedMatchScorDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static async getCompletedMatchScore (id: number) {
      return http.get(`/completedMatches/${id}`)
    }
  }
}

export default new CompletedMatches()
